export default __webpack_public_path__ + "static/media/pdf-text.91c0a57f.svg";